import { Helmet } from 'react-helmet-async'

// Set VITE_ROBOTS_NOINDEX=true in staging CI to prevent indexation of non-production deployments.
const robotsContent = import.meta.env.VITE_ROBOTS_NOINDEX === 'true'
    ? 'noindex, nofollow'
    : 'index, follow'

interface SEOTagsProps {
    title: string
    description: string
    url: string
    schema?: string
    ogImage?: string
    ogType?: string
}

export function SEOTags({
    title,
    description,
    url,
    schema,
    ogImage = 'https://steadfasthsa.com/og-image.png',
    ogType = 'website',
}: SEOTagsProps) {
    return (
        <Helmet>
            {/* Standard Meta Tags */}
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="robots" content={robotsContent} />
            <link rel="canonical" href={url} />

            {/* Open Graph Tags */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:type" content={ogType} />
            <meta property="og:image" content={ogImage} />

            {/* Twitter Tags */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />

            {/* JSON-LD Schema (if provided) */}
            {schema && (
                <script type="application/ld+json">
                    {schema}
                </script>
            )}
        </Helmet>
    )
}
